import React from 'react'
import { Link, useNavigate } from 'react-router-dom'
import { CompanyForm } from '@/components/company/CompanyForm'

const CompanyCreate: React.FC = () => {
  const navigate = useNavigate()

  return (
    <div className="container-custom py-8">
      <Link to="/companies" className="mb-5 inline-flex text-sm text-primary-700 hover:underline">
        ← К списку компаний
      </Link>
      <div className="mb-6">
        <h1 className="text-2xl font-bold text-secondary-900">Добавить компанию</h1>
        <p className="mt-1 text-sm text-secondary-600">Заполните профиль компании, чтобы размещать вакансии от её имени.</p>
      </div>
      <div className="rounded-xl border border-secondary-200 bg-white p-5 shadow-sm sm:p-7">
        <CompanyForm onSuccess={() => navigate('/companies')} onCancel={() => navigate('/companies')} />
      </div>
    </div>
  )
}

export default CompanyCreate
